import { Injectable } from '@angular/core';
import { FejlDashboardService as FejlDashboardServiceBE } from 'src/app/api/services/fejl-dashboard.service';
import { EGIS_SERVICE_CALLER } from '../../constants';
import { FejlDashboardSubSummaryDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-sub-summary-dto';
import { FejlDashboardTypeEnum } from 'src/app/api/models/OK/Egis/Service/Models/DTO/Enums/fejl-dashboard-type-enum';
import { FejlDashboardDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-dto';
import { FejlDashboardSummaryDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/fejl-dashboard-summary-dto';
import { FejlDashbordRetFejlRequest } from 'src/app/api/models/OK/Egis/Service/Models/Request/fejl-dashbord-ret-fejl-request';
import { NotificationService } from '../../notifications/services/notification.service';
import { BehaviorSubject, finalize, map, Observable, tap, timer } from 'rxjs';
import { OrdreService } from '../../services/ordre.service';
import { ServiceordreValidationFailedReasonEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-validation-failed-reason-enum';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { Router } from '@angular/router';
import { Loader, LoaderService } from '../../services/loader.service';
import { SignalrService } from 'src/app/services/signalr.service';
import { AuthService } from 'src/app/services/auth.service';
import { SettlementService } from 'src/app/services/settlement.service';
import { KundesegmentEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/kundesegment-enum';

@Injectable({
  providedIn: 'root',
})
export class FejlDashboardService {
  private antalFejl: number = 0;
  private subtyper: FejlDashboardSubSummaryDto[] = [];
  private fejlDashboardSummary: FejlDashboardSummaryDto = null;

  public summaryLoading$ = new BehaviorSubject<boolean>(false);

  public subSummaryUpdated$ = new BehaviorSubject<FejlDashboardSubSummaryDto>(null);
  public summaryUpdated$ = new BehaviorSubject<FejlDashboardSummaryDto>(null);

  active: FejlDashboardTypeEnum;

  get activeSummary() {
    return this.subtyper.find((p) => p.fejlDashboardType == this.active);
  }

  fejletOverfoerselLoader: Loader;
  fejletOrdreAfregningLoader: Loader;
  fejletDannelseAfEftersynKreditstopLoader: Loader;
  fejletDannelseAfEftersynFlereEftersynLoader: Loader;
  customerOpkraevningHaltedLoader: Loader;
  createEftersynHaltedLoader: Loader;
  slutopgoerelserHaltedLoader: Loader;
  serviceintervallerLoader: Loader;
  postnummerUdenPartnerLoader: Loader;
  afregningerHaltedLoader: Loader;

  constructor(
    private backend: FejlDashboardServiceBE,
    private notification: NotificationService,
    private ordreService: OrdreService,
    private router: Router,
    private loader: LoaderService,
    private signalr: SignalrService,
    private auth: AuthService,
    private settlementService: SettlementService,
  ) {
    this.fejletOverfoerselLoader = this.loader.createLoader({});
    this.fejletOrdreAfregningLoader = this.loader.createLoader({});
    this.fejletDannelseAfEftersynKreditstopLoader = this.loader.createLoader({});
    this.fejletDannelseAfEftersynFlereEftersynLoader = this.loader.createLoader({});
    this.customerOpkraevningHaltedLoader = this.loader.createLoader({});
    this.createEftersynHaltedLoader = this.loader.createLoader({});
    this.slutopgoerelserHaltedLoader = this.loader.createLoader({});
    this.serviceintervallerLoader = this.loader.createLoader({});
    this.postnummerUdenPartnerLoader = this.loader.createLoader({});
    this.afregningerHaltedLoader = this.loader.createLoader({});
  }

  init() {
    if (!this.auth.isAdministrator && !this.auth.isSuperuser && !this.auth.isReadonly) return;

    this.hentStatus();

    this.signalr.fejlDashboardSummary$.pipe(tap((w) => {})).subscribe((data: FejlDashboardSummaryDto) => {
      this.subtyper = data.fejlDashboardTyper;
      this.antalFejl = data.antalFejl;
      this.summaryUpdated$.next(data);
      data.fejlDashboardTyper.forEach((subSummary: FejlDashboardSubSummaryDto) => {
        this.subSummaryUpdated$.next(subSummary);
      });
    });
  }

  hentStatus() {
    this.createEftersynHaltedLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.CreateEftersynHalted })
      .pipe(
        finalize(() => {
          this.createEftersynHaltedLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.customerOpkraevningHaltedLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.CustomerOpkraevningHalted })
      .pipe(
        finalize(() => {
          this.customerOpkraevningHaltedLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.fejletOrdreAfregningLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.FejletOrdreAfregning })
      .pipe(
        finalize(() => {
          this.fejletOrdreAfregningLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.fejletDannelseAfEftersynFlereEftersynLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.FejletDannelseAfEftersynFlereEftersyn })
      .pipe(
        finalize(() => {
          this.fejletDannelseAfEftersynFlereEftersynLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.fejletOverfoerselLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.FejletOverfoersel })
      .pipe(
        finalize(() => {
          this.fejletOverfoerselLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.slutopgoerelserHaltedLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.SlutopgoerelserHalted })
      .pipe(
        finalize(() => {
          this.slutopgoerelserHaltedLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.serviceintervallerLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.Serviceintervaller })
      .pipe(
        finalize(() => {
          this.serviceintervallerLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.fejletDannelseAfEftersynKreditstopLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.FejletDannelseAfEftersynKreditstop })
      .pipe(
        finalize(() => {
          this.fejletDannelseAfEftersynKreditstopLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.postnummerUdenPartnerLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.PostnummerUdenPartner })
      .pipe(
        finalize(() => {
          this.postnummerUdenPartnerLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );

    this.afregningerHaltedLoader.start();
    this.backend
      .fejlDashboardSubSummary({ caller: EGIS_SERVICE_CALLER, type: FejlDashboardTypeEnum.AfregningerHalted })
      .pipe(
        finalize(() => {
          this.afregningerHaltedLoader.stop();
        }),
      )
      .subscribe(
        (result) => {
          this.updateSummary(result);
        },
        () => {},
      );
  }

  updateSummary(subSummmary: FejlDashboardSubSummaryDto) {
    this.subSummaryUpdated$.next(subSummmary);

    if (this.fejlDashboardSummary == null) {
      this.fejlDashboardSummary = {
        antalFejl: 0,
        fejlDashboardTyper: [],
      };
    }

    this.fejlDashboardSummary.fejlDashboardTyper.push(subSummmary);
    this.fejlDashboardSummary.antalFejl += subSummmary.antalFejl;
    this.antalFejl += subSummmary.antalFejl;
    this.subtyper.push(subSummmary);
    this.summaryUpdated$.next(this.fejlDashboardSummary);
  }

  hentList(type: FejlDashboardTypeEnum): Observable<FejlDashboardDto[]> {
    return this.backend.fejlDashboardListe({ caller: EGIS_SERVICE_CALLER, type: type }).pipe(map((val) => val.fejlListe));
  }

  text(dto: FejlDashboardSubSummaryDto, antalFejl: number) {
    switch (dto.fejlDashboardType) {
      case FejlDashboardTypeEnum.SlutopgoerelserHalted:
        return antalFejl > 1 ? 'slutopgørelser' : 'slutopgørelse';
      case FejlDashboardTypeEnum.CustomerOpkraevningHalted:
      case FejlDashboardTypeEnum.CreateEftersynHalted:
      case FejlDashboardTypeEnum.SlutopgoerelserHalted:
      case FejlDashboardTypeEnum.Serviceintervaller:
        return antalFejl > 1 ? 'aftaler' : 'aftale';
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynKreditstop:
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynFlereEftersyn:
      case FejlDashboardTypeEnum.FejletOverfoersel:
      case FejlDashboardTypeEnum.FejletOrdreAfregning:
        return antalFejl > 1 ? 'ordrer' : 'ordre';
      case FejlDashboardTypeEnum.PostnummerUdenPartner:
        return antalFejl > 1 ? 'postnumre' : 'postnummer';
      case FejlDashboardTypeEnum.AfregningerHalted:
        return antalFejl > 1 ? 'afregninger' : 'afregning';
      default:
        return 'ordrer';
    }
  }

  title(fejlDashboardType: FejlDashboardTypeEnum) {
    switch (fejlDashboardType) {
      case FejlDashboardTypeEnum.FejletOrdreAfregning:
        return 'Fejlet under fakturering';
      case FejlDashboardTypeEnum.FejletOverfoersel:
        return 'Ikke overført til S-partner';
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynKreditstop:
        return 'Kreditstop valideringsfejl';
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynFlereEftersyn:
        return 'Valideringsfejl pga. flere eftersyn';
      case FejlDashboardTypeEnum.CustomerOpkraevningHalted:
        return 'Opkrævning gået i stå';
      case FejlDashboardTypeEnum.CreateEftersynHalted:
        return 'Eftersyn kunne ikke dannes pga. ophørt s-partner';
      case FejlDashboardTypeEnum.SlutopgoerelserHalted:
        return 'Slutopgørelser gået i stå';
      case FejlDashboardTypeEnum.Serviceintervaller:
        return 'Overlappende serviceintervaller';
      case FejlDashboardTypeEnum.PostnummerUdenPartner:
        return 'Postnumre uden partner';
      case FejlDashboardTypeEnum.AfregningerHalted:
        return 'Afregninger mod G4 gået i stå';
      default:
        return 'Ikke implementeret';
    }
  }

  private retKreditstop(serviceordre: ServiceordreDto): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.ordreService.kreditstop$(serviceordre).subscribe({
        next(v) {
          resolve(v);
        },
        error(err) {
          reject(err);
        },
      });
    });
  }

  private retSettlementHalted(
    settlementId: number,
    errorTextG4: string,
    isCreditnote: boolean,
    creditnoteBilagsnr?: number,
    creditnoteOpkraevningDate?: Date,
    agreementNo?: number,
    serviceorderNo?: number,
    amountExclVat?: number,
    amountInclVat?: number,
  ): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.settlementService
        .settlementHalted$(
          settlementId,
          errorTextG4,
          isCreditnote,
          creditnoteBilagsnr,
          creditnoteOpkraevningDate,
          agreementNo,
          serviceorderNo,
          amountExclVat,
          amountInclVat,
        )
        .subscribe({
          next(v) {
            resolve(v);
          },
          error(err) {
            reject(err);
          },
        });
    });
  }

  private handleValidationFailed(serviceordre: ServiceordreDto): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.ordreService.handleValidationFailed$(serviceordre).subscribe({
        next(v: null | void) {
          resolve(v !== null);
        },
        error(err) {
          reject(err);
        },
      });
    });
  }

  private retFejlDashboardListe(request: FejlDashbordRetFejlRequest): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.backend.retFejlDashboardListe({ caller: EGIS_SERVICE_CALLER, body: request }).subscribe({
        next(v: null | void) {
          resolve(v !== null);
        },
        error(err) {
          reject(err);
        },
      });
    });
  }

  async retFejl(ids: Array<FejlDashboardDto>) {
    if (ids?.length) {
      try {
        let status: Boolean = false;
        const {
          serviceordreNr,
          partnerValidTo,
          okKundeAftaleNr,
          opgave,
          partnerNo,
          fejl,
          id,
          isCreditnote,
          creditnoteBilagsnr,
          creditnoteOpkraevningDate,
          amountExclVat,
          amountInclVat,
          kundesegment,
        } = ids[0];
        //validering fejlet dialog kreditstop
        switch (this.active) {
          case FejlDashboardTypeEnum.FejletDannelseAfEftersynKreditstop:
            status = !!(await this.retKreditstop({
              serviceordreNo: serviceordreNr,
              okKundeAftalenr: okKundeAftaleNr,
              serviceordreType: opgave,
              partner: { validTo: partnerValidTo },
            }));
            break;

          case FejlDashboardTypeEnum.FejletDannelseAfEftersynFlereEftersyn:
            status = !!(await this.handleValidationFailed({
              serviceordreNo: serviceordreNr,
              serviceordreValidationFailedReason: ServiceordreValidationFailedReasonEnum.MultipleEftersynInServiceInterval,
            }));
            break;

          case FejlDashboardTypeEnum.CreateEftersynHalted:
            this.router.navigate(['/partnerchange', partnerNo, { page: this.active }]);
            return;

          case FejlDashboardTypeEnum.PostnummerUdenPartner:
            this.router.navigate(['/indstillinger'], { fragment: 'postnummer' });
            return;

          case FejlDashboardTypeEnum.AfregningerHalted:
            status = !!(await this.retSettlementHalted(
              id,
              fejl,
              isCreditnote,
              creditnoteBilagsnr,
              new Date(creditnoteOpkraevningDate),
              okKundeAftaleNr,
              serviceordreNr,
              kundesegment == KundesegmentEnum.Erhverv ? amountExclVat : null,
              kundesegment == KundesegmentEnum.Privat ? amountInclVat : null,
            ));
            break;

          default:
            const request: FejlDashbordRetFejlRequest = {
              fejlDashboardType: this.active,
              ids: ids.map((p) => p.id),
            };
            status = !!(await this.retFejlDashboardListe(request));

            break;
        }

        if (status) {
          this.notification.success('Fejl forsøgt rettet - afvent status ændring');
          await timer(1000).subscribe((p) => {
            this.hentStatus();
          });
        }
      } catch (e) {
        this.notification.error('Fejl forsøgt rettet fejlede');
      }
    }
  }

  button(antal: null | number) {
    const summary: FejlDashboardSubSummaryDto = this.activeSummary;
    let result = '';
    switch (this.active) {
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynKreditstop:
      case FejlDashboardTypeEnum.FejletDannelseAfEftersynFlereEftersyn:
        result = 'Godkend/Annuller';
        break;
      case FejlDashboardTypeEnum.FejletOverfoersel:
        result = 'Gensend';
        break;
      case FejlDashboardTypeEnum.CreateEftersynHalted:
        return 'Masseskift af partner';
      case FejlDashboardTypeEnum.SlutopgoerelserHalted:
        result = 'Afregn';
        break;
      case FejlDashboardTypeEnum.PostnummerUdenPartner:
        result = 'Åbn';
        break;
      case FejlDashboardTypeEnum.AfregningerHalted:
        result = 'Behandl fejlet';
        break;
      default:
        result = 'Åben';
        break;
    }
    if (!antal) return `${result} ${this.text(summary, antal ? antal : 0)}`;
    return `${result} ${antal} ${this.text(summary, antal ? antal : 0)}`;
  }
}
